module.exports = __webpack_public_path__ + "img/industryPage1_3.3f978614.png";